document.addEventListener("DOMContentLoaded", () => {
  const submitButton = document.querySelector("#contact-form-submit");
  const phoneInput = document.querySelector("#contact-phone");
  const submitText = document.querySelector(".submit-form-text");
  const submitLoader = document.querySelector(".submit-form-loader");

  const clearForm = () => {
    document.querySelector("#contact-first-name").value = "";
    document.querySelector("#contact-last-name").value = "";
    document.querySelector("#contact-email").value = "";
    document.querySelector("#contact-phone").value = "";
    document.querySelector("#company-name").value = "";
    document.querySelector("#company-size").value =
      document.querySelector("#company-size").options[0].value;
  };

  // Restrict phone input to numbers, +, and #
  phoneInput.addEventListener("input", (e) => {
    e.target.value = e.target.value.replace(/[^0-9+#]/g, "");
  });

  const validateField = (value, fieldName) => {
    const errorElement = document.querySelector(`#error-${fieldName}`);
    if (!value.trim()) {
      errorElement.textContent = `Please fill out ${fieldName.replace(
        "-",
        " "
      )}`;
      return false;
    }
    errorElement.textContent = "";
    return true;
  };

  const validateEmail = (email) => {
    const errorElement = document.querySelector("#error-email");
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email.trim()) {
      errorElement.textContent = "Please fill out email";
      return false;
    }
    if (!emailRegex.test(email)) {
      errorElement.textContent = "Please enter a valid email address";
      return false;
    }
    errorElement.textContent = "";
    return true;
  };

  const validatePhone = (phone) => {
    const errorElement = document.querySelector("#error-phone");
    if (!phone.trim()) {
      errorElement.textContent = "Please fill out phone";
      return false;
    }
    if (phone.length < 10) {
      errorElement.textContent = "Phone number must be at least 10 digits";
      return false;
    }
    errorElement.textContent = "";
    return true;
  };

  submitButton.addEventListener("click", async (e) => {
    e.preventDefault();
    submitText.classList.add("hidden-span");
    submitLoader.classList.remove("hidden-span");

    // Get plan from URL parameters
    const urlParams = new URLSearchParams(window.location.search);
    const plan = urlParams.get("plan");

    const formData = {
      firstName: document.querySelector("#contact-first-name").value,
      lastName: document.querySelector("#contact-last-name").value,
      email: document.querySelector("#contact-email").value,
      phone: document.querySelector("#contact-phone").value,
      companyName: document.querySelector("#company-name").value,
      companySize:
        document.querySelector("#company-size").value === "1001"
          ? "1001 - 10000"
          : document.querySelector("#company-size").value === "10001"
          ? "10001+"
          : document.querySelector("#company-size").value,
      interested_plan:
        plan === "growth" ? "Growth" : plan === "essential" ? "Essential" : "", // Add plan if it exists, empty string if not
    };

    // Validate all fields
    const isFirstNameValid = validateField(formData.firstName, "first-name");
    const isLastNameValid = validateField(formData.lastName, "last-name");
    const isEmailValid = validateEmail(formData.email);
    const isPhoneValid = validatePhone(formData.phone);
    const isCompanyValid = validateField(formData.companyName, "company");

    // Only proceed if all validations pass
    if (
      isFirstNameValid &&
      isLastNameValid &&
      isEmailValid &&
      isPhoneValid &&
      isCompanyValid
    ) {
      await fetch("https://hooks.zapier.com/hooks/catch/14219411/2k6huab/", {
        method: "POST",
        body: JSON.stringify(formData),
      })
        .then((response) => response.json())
        .then(async (data) => {
          if (data.status === "success") {
            const redirect_url = `/pages/contact-request-sent?name=${encodeURIComponent(
              formData.firstName
            )}`;
            gtag_report_conversion(redirect_url, "demo_request");

            // TriplePixel tracking for teams_contact_form event
            TriplePixel("custom", "teams_contact_form", {
              name: formData.firstName + " " + formData.lastName,
              company: formData.companyName,
              email: formData.email,
              company_size: formData.companySize,
            });

            clearForm();
          }
          submitText.classList.remove("hidden-span");
          submitLoader.classList.add("hidden-span");
        })
        .catch((error) => {
          console.log("error submitting");
          submitText.classList.remove("hidden-span");
          submitLoader.classList.add("hidden-span");
        });
    } else {
      submitText.classList.remove("hidden-span");
      submitLoader.classList.add("hidden-span");
    }
  });
});
